import { render } from "./stats.vue?vue&type=template&id=a517aeb4"
import script from "./stats.vue?vue&type=script&lang=js"
export * from "./stats.vue?vue&type=script&lang=js"

import "./stats.vue?vue&type=style&index=0&id=a517aeb4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__